import { cn } from "../../lib/utils";
import { createTheme } from "../../styles/theme";
import { CardProps } from "../../types/components";

/**
 * Consistent Card component with standardized styling
 */
function Card({
  className,
  children,
  title,
  subtitle,
  actions,
  isLightMode = false,
  ...props
}: CardProps) {
  const theme = createTheme(isLightMode);

  return (
    <div
      className={cn(
        "rounded-lg overflow-hidden shadow-md border",
        theme.components.card,
        className
      )}
      {...props}
    >
      {(title || subtitle) && (
        <div className={cn("p-4 font-bold", theme.colors.text.primary)}>
          {title && <h3 className="text-lg font-bold">{title}</h3>}
          {subtitle && <p className="text-base opacity-75 mt-1">{subtitle}</p>}
        </div>
      )}

      <div className={cn("p-4", theme.colors.text.primary)}>{children}</div>

      {actions && <div className="p-4 pt-0 flex justify-end space-x-2">{actions}</div>}
    </div>
  );
}

export default Card;
